import React from 'react';

import { StudentAudioAssetPlayer } from '../../../components/Audio/editorComponents/StudentAudioAssetPlayer';
import { isSequencedFlowStep, Section, SequencedFlowStep } from '@ael/core-api';

import './content-renderer.scss';

type LinearFlowStepAudioPlayerProps = {
  isMobile: boolean;
  linearFlowStep: SequencedFlowStep | Section;
};

export const LinearFlowStepAudioPlayer = (props: LinearFlowStepAudioPlayerProps) => {
  if (!isSequencedFlowStep(props.linearFlowStep) || !props.linearFlowStep.audioAsset) {
    return null;
  }

  return (
    <StudentAudioAssetPlayer
      uniqueAudioKey={props.linearFlowStep.id}
      audioAsset={props.linearFlowStep.audioAsset}
      isMobileDevice={props.isMobile}
    />
  );
};
